import { useQuery } from "@tanstack/react-query";

import useSystemStore from "@store/useSystemStore";
import companyService from "@services/company.service";
import { QUERY_CACHE_DEFAULT_EXPIRATION_MS, COMPANY_QUERY_KEY } from "@config/query";

export function useGetCompany(companyId?: string) {
  const { isAppActive } = useSystemStore();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: isAppActive && !!companyId,
    queryKey: [COMPANY_QUERY_KEY, companyId],
    queryFn: async () => {
      return await companyService.getCompanyById(companyId);
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
